import MarkdownComp from 'react-markdown'
import remarkGfm from 'remark-gfm'
export function Markdown({ markdown }: { markdown: string }) {
  return <MarkdownComp remarkPlugins={[remarkGfm]}
    className='w-full prose lg:prose-base'>
    {markdown}
  </MarkdownComp>
}